module.exports = __webpack_public_path__ + "static/image1995-2bfd1babfbc8770869a54bcdd756df18.jpeg";